/* @ngInject */
function formattedStatusFilter ($filter, $translate) {
  return function (status, isUser, isConsultant, isGroupManager) {
    let prefix = ''
    if (isUser && !isConsultant && !isGroupManager) {
      prefix = 'workflowUser.'
    } else if (isUser && (isConsultant || isGroupManager)) {
      prefix = 'workflowConsultant.'
    }

    switch (status) {
      case 'WAITING_PRE_APPROVAL':
        return $translate.instant(`${prefix}${isGroupManager ? 'waitingOwner' : 'waitingMyApproval'}`)
      case 'WAITING_RESPONSE':
        return $translate.instant(`${prefix}waiting`)
      case 'PROGRESS':
        return $translate.instant(`${prefix}inProgress`)
      case 'REVIEW':
        return $translate.instant(`${prefix}underReview`)
      case 'DONE':
        return $translate.instant(`${prefix}done`)
      case 'REJECTED':
        return $translate.instant(`${prefix}rejected`)
      case 'WAITING_USER_ADJUST':
        return $translate.instant(`${prefix}adjustments`)
      case 'INBOX':
        return $translate.instant(`${prefix}inbox`)
      default:
        return $translate.instant(`${prefix}status`)
    }
  }
}

export { formattedStatusFilter }
